import { useNumberUtils } from '@99fun-agent/cores'

let _numberLocale = 'en-US'
const unitSystem = [
  {
    value: 1e9,
    short: 'B',
    long: 'Billion',
    threshold: 1e9
  },
  {
    value: 1e6,
    short: 'M',
    long: 'Million',
    threshold: 1e6
  },
  {
    value: 1e3,
    short: 'K',
    long: 'Thousand',
    threshold: 1e3
  }
]
/**
 *
 * @param val
 * @returns
 */
const formatFullNumber = (val: number | string, decimals = 2) => {
  // 处理各种输入
  const number = typeof val === 'string' ? parseFloat(val) : val

  if (isNaN(number)) return 'NaN'

  // 截断到指定小数位
  const factor = 10 ** decimals
  const truncated = Math.trunc(number * factor) / factor

  // 南亚格式化
  return new Intl.NumberFormat(_numberLocale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals
  }).format(truncated)
}

const { applyRounding } = useNumberUtils()
const formatIndianUnits = (
  number: string | number,
  options: {
    decimals?: number
    shortFormat?: boolean
    showFullName?: boolean
    locale?: string
    withCommas?: boolean
    // minUnit?: ''
  } = {}
) => {
  const {
    decimals = 2,
    shortFormat = true, // true: "1.5L", false: "1.5 Lakh"
    showFullName = false, // 显示完整名称
    locale = _numberLocale,
    withCommas = true // 数字部分是否加逗号

    // minUnit = 'auto', // 最小显示单位: 'auto', 'lakh', 'crore', etc.
    // maxUnit = 'auto' // 最大显示单位
  } = options

  const num = Number(number)
  if (isNaN(num)) return String(number)

  const absNum = Math.abs(num)
  const isNegative = num < 0

  // 完整的单位系统

  // 查找合适的单位
  let selectedUnit = null
  for (const unit of unitSystem) {
    if (absNum >= unit.threshold) {
      selectedUnit = unit
      break
    }
  }

  // 如果没找到合适的大单位，直接格式化
  if (!selectedUnit || selectedUnit.value < 1000) {
    return formatFullNumberWithDigits(num)
  }

  // 计算数值
  const unitValue = applyRounding(num / selectedUnit.value, 2, 'truncate')

  // 格式化数字部分
  let numberPart
  if (withCommas) {
    const formatter = new Intl.NumberFormat(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals
    })
    numberPart = formatter.format(unitValue)
  } else {
    // 移除末尾的零
    const fixed = unitValue.toFixed(decimals)
    numberPart = fixed.replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1')
  }

  // 构建单位部分
  let unitPart
  if (showFullName) {
    unitPart = ' ' + selectedUnit.long
  } else if (shortFormat) {
    unitPart = selectedUnit.short
  } else {
    unitPart = ' ' + selectedUnit.short
  }

  // 添加货币符号
  let prefix = isNegative ? '-' : ''

  return prefix + numberPart + unitPart
}

/**
 * 数字整体用分隔符格式化 最多两位小数
 * @param val
 * @returns
 */
const formatFullNumberWithDigits = (val: number | string) => {
  return formatFullNumber(val)
}

/**
 * 数字整体用分隔符格式化  不带小数
 * @param val
 * @returns
 */
const formatFullNumberNoDigits = (val: number | string) => {
  return formatFullNumber(val, 0)
}

/**
 * 带单位缩写的格式化，最多两位小数
 * @param val
 * @returns
 */
const formatNumberUnits = (val: number | string) => {
  return formatIndianUnits(val, {
    decimals: 2,
    shortFormat: true,
    withCommas: true
  })
}

/**
 * 带单位缩写的格式化，不带小数
 * @param val
 * @returns
 */
const formatNumberUnitNoDigits = (val: number | string) => {
  return formatIndianUnits(val, {
    decimals: 0,
    shortFormat: true,
    withCommas: true
  })
}

let _currencyFomatter: (val: string) => string
const installCurrency = (formatter: (val: string) => string) => {
  _currencyFomatter = formatter
}

const formatCurrency = (val: string) => {
  if (_currencyFomatter) {
    return _currencyFomatter(val)
  }
  return val
}

export const useLocale = () => {
  return {
    formatFullNumber,
    formatFullNumberNoDigits,
    formatFullNumberWithDigits,
    formatNumberUnits,
    formatNumberUnitNoDigits,
    installCurrency,
    formatCurrency
  }
}
